import SystemKnowledgeTypeText from "../texts/SystemKnowledgeTypeText";
import {SystemKnowledgeDefinitionText} from "../texts/SystemKnowledgeDefinitionText";
import {isNullOrUndefined} from "../../services/Validator";

export default function SystemLevelAKnowledgeDefinition({knowledge}) {
    // Used in SingleKnowledgeScreen to display
    // type and definition texts

    // BUILD
    if (isNullOrUndefined(knowledge))
        return null
    return (
        <div className={"w-full flex flex-col justify-start items-start px-[12px] py-[8px] border-primaryLight3 border-[1px] rounded-[12px]"}>
            <SystemKnowledgeTypeText knowledgeType={knowledge.type} />
            <SystemKnowledgeDefinitionText knowledgeDefinition={knowledge.definition} />
        </div>
    );
}